const Albums = ({
  color = '#E9BF6E',
  width = 24,
  height = 25,
}: {
  color?: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_i_235_20134)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 5.17218C11 3.8954 12.1801 2.94553 13.4274 3.21838L19.4274 4.53088C20.3456 4.73173 21 5.5448 21 6.48468V17.8749C21 18.8148 20.3456 19.6278 19.4274 19.8287L13.4274 21.1412C12.1801 21.414 11 20.4642 11 19.1874V5.17218ZM19 6.48468L13 5.17218V19.1874L19 17.8749V6.48468ZM8 4.17978C8.55228 4.17978 9 4.6275 9 5.17978V19.1798C9 19.7321 8.55228 20.1798 8 20.1798C7.44772 20.1798 7 19.7321 7 19.1798V5.17978C7 4.6275 7.44772 4.17978 8 4.17978ZM4 5.17978C4.55228 5.17978 5 5.6275 5 6.17978V18.1798C5 18.7321 4.55228 19.1798 4 19.1798C3.44772 19.1798 3 18.7321 3 18.1798V6.17978C3 5.6275 3.44772 5.17978 4 5.17978Z"
          fill={color}
        />
      </g>
      <defs>
        <filter
          id="filter0_i_235_20134"
          x="3"
          y="3.17139"
          width="18"
          height="18.0168"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1" dy="0.1" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.867236 0 0 0 0 0.867236 0 0 0 0 0.867236 0 0 0 0.31 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_235_20134" />
        </filter>
      </defs>
    </svg>
  );
};

export default Albums;
